<script setup>
import DateTimePicker from '@/components/DateTimePicker.vue'
import { ref } from 'vue'

definePage({
  meta: {
    layout: 'default',
    public: true,
  },
})

// --- STATE ---
const form = ref({
  published_at: '2024-05-20 15:30:00',
  start_date: '2024-05-20 15:30',
  appointment: '',
  delivery: '',
  scheduled_at: '',
  localized_date: '',
})

// Example 3 props
const estheticTextFieldProps = { 
  variant: 'filled', 
  density: 'compact', 
  prependIcon: 'mdi-event', 
}

const estheticDatePickerProps = { 
  color: 'deep-purple',
  elevation: 10, 
}

const estheticTimePickerProps = {
  landscape: true,
}

// Example 4 props
const futureDatePickerProps = { 
  min: new Date().toISOString().split('T')[0], 
}
</script>

<template>
  <VContainer class="py-6">
    <VCard class="mb-6">
      <VCardTitle class="text-h5">
        DateTimePicker Demo
      </VCardTitle>
      <VCardSubtitle>
        Componente per la selezione di Data e Ora compatibile con Laravel.
      </VCardSubtitle>
    </VCard>

    <VRow>
      <!-- 1. Utilizzo Base -->
      <VCol
        cols="12"
        md="6"
      >
        <VCard title="1. Utilizzo Base (Formato Laravel)">
          <VCardText>
            <p class="mb-4">
              Restituisce: YYYY-MM-DD HH:mm:ss
            </p>
            <DateTimePicker v-model="form.published_at" />
            <VAlert
              type="info"
              variant="tonal"
              class="mt-4"
            >
              Value: {{ form.published_at }}
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 2. Formato Personalizzato -->
      <VCol
        cols="12"
        md="6"
      >
        <VCard title="2. Formato Personalizzato (Senza secondi)">
          <VCardText>
            <p class="mb-4">
              Output format: YYYY-MM-DD HH:mm
            </p>
            <DateTimePicker 
              v-model="form.start_date" 
              output-format="YYYY-MM-DD HH:mm"
            />
            <VAlert
              type="info"
              variant="tonal"
              class="mt-4"
            >
              Value: {{ form.start_date }}
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 3. Personalizzazione Estetica -->
      <VCol
        cols="12"
        md="6"
      >
        <VCard title="3. Personalizzazione Estetica">
          <VCardText>
            <p class="mb-4">
              Props Vuetify (variant filled, deep-purple color)
            </p>
            <DateTimePicker 
              v-model="form.appointment"
              label-date="Giorno dell'appuntamento"
              label-time="Orario preferito"
              :text-field-props="estheticTextFieldProps"
              :date-picker-props="estheticDatePickerProps"
              :time-picker-props="estheticTimePickerProps"
            />
            <VAlert
              type="info"
              variant="tonal"
              class="mt-4"
            >
              Value: {{ form.appointment }}
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 4. Limitazioni delle Date -->
      <VCol
        cols="12"
        md="6"
      >
        <VCard title="4. Limitazioni (Solo futuro)">
          <VCardText>
            <p class="mb-4">
              Solo date future ammesse
            </p>
            <DateTimePicker 
              v-model="form.delivery"
              :date-picker-props="futureDatePickerProps"
            />
            <VAlert
              type="info"
              variant="tonal"
              class="mt-4"
            >
              Value: {{ form.delivery }}
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 5. Formato ISO 8601 -->
      <VCol
        cols="12"
        md="6"
      >
        <VCard title="5. ISO 8601 (Laravel Validated)">
          <VCardText>
            <p class="mb-4">
              Output ISO con Timezone (per validazione strict)
            </p>
            <DateTimePicker 
              v-model="form.scheduled_at"
              output-format="iso"
              label-date="Scheduled Date"
              label-time="Scheduled Time"
            />
            <VAlert
              type="info"
              variant="tonal"
              class="mt-4"
            >
              Value: {{ form.scheduled_at }}
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 6. Display Locale -->
      <VCol
        cols="12"
        md="6"
      >
        <VCard title="6. Display Locale (en-GB)">
          <VCardText>
            <p class="mb-4">
              Visualizzazione data in italiano
            </p>
            <DateTimePicker 
              v-model="form.localized_date"
              display-locale="en-GB"
              label-date="Data (Italiano)"
            />
            <VAlert
              type="info"
              variant="tonal"
              class="mt-4"
            >
              Value: {{ form.localized_date }}
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>
